module.exports = __webpack_public_path__ + "static/media/20.c5853c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/20.png
// module id = 1126
// module chunks = 0